function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.6602 0.00012207C18.0602 0.00012207 20.0002 1.92012 20.0002 5.33012V14.6701C20.0002 18.0601 18.0702 20.0001 14.6702 20.0001H5.33018C1.92018 20.0001 0.000183105 18.0601 0.000183105 14.6701V5.33012C0.000183105 1.92012 1.92018 0.00012207 5.33018 0.00012207H14.6602ZM9.99018 5.51012C9.53018 5.51012 9.16018 5.88012 9.16018 6.34012V9.16012H6.33018C6.11018 9.16012 5.90018 9.25012 5.74018 9.40012C5.59018 9.56012 5.50018 9.76912 5.50018 9.99012C5.50018 10.4501 5.87018 10.8201 6.33018 10.8301H9.16018V13.6601C9.16018 14.1201 9.53018 14.4901 9.99018 14.4901C10.4502 14.4901 10.8202 14.1201 10.8202 13.6601V10.8301H13.6602C14.1202 10.8201 14.4902 10.4501 14.4902 9.99012C14.4902 9.53012 14.1202 9.16012 13.6602 9.16012H10.8202V6.34012C10.8202 5.88012 10.4502 5.51012 9.99018 5.51012Z",
  fill: "white"
});

var SvgPlus = function SvgPlus(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPlus, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Plus.dea9afe0.svg";
export { ForwardRef as ReactComponent };